/**
 * Shared dialog styles configuration
 * Used across all dialog components for consistent styling
 */
export const styles = {
  paper: {
    borderRadius: 2,
    textAlign: 'center',
  },
  content: {
    p: 2,
  },
  actions: {
    px: 2,
    pb: 2,
    justifyContent: 'center',
    gap: 1,
  },
  button: {
    fullWidth: true,
    size: 'large',
    sx: { maxWidth: 250 },
  },
}
